import { render, staticRenderFns } from "./PostsDetails.vue?vue&type=template&id=367610b4&scoped=true"
import script from "./PostsDetails.vue?vue&type=script&lang=js"
export * from "./PostsDetails.vue?vue&type=script&lang=js"
import style0 from "./PostsDetails.vue?vue&type=style&index=0&id=367610b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367610b4",
  null
  
)

export default component.exports